<template>
  <transition name="el-fade-in-linear">
    <div
      v-if="visible && programData"
      ref="preview"
      class="preview"
      @mousewheel.prevent
    >
      <div class="main-area">
        <div class="container" style="border: 2px solid #fff">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            row-key="id"
            @row-click="singleElection"
            class="bindGoodsDialog"
          >
            <el-table-column align="center" width="55">
              <el-table-column width="30" align="center">
                <template slot="header"> </template>
                <template slot-scope="scope">
                  <el-radio
                    class="radio"
                    v-model="templateSelection"
                    :label="scope.row.itemId"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
            </el-table-column>
            <!-- 门店名称 -->
            <el-table-column
              :label="$t('assocaite.DiologTwo.table.Store Name')"
              prop="storeName"
            >
              <el-table-column prop="storeName" min-width="150" align="center">
                <template slot="header">
                  <el-input
                    v-model="goodsParams.storeName"
                    size="mini"
                    placeholder=""
                    @input="getItemList"
                    clearable
                  />
                </template>
              </el-table-column>
            </el-table-column>
            <!-- 商品名称 -->
            <el-table-column
              :label="$t('assocaite.DiologTwo.table.Goods Name')"
              prop="itemName"
            >
              <el-table-column prop="itemName" min-width="150" align="center">
                <template slot="header">
                  <el-input
                    v-model="goodsParams.itemName"
                    size="mini"
                    placeholder=""
                    @input="getItemList"
                    clearable
                  />
                </template>
              </el-table-column>
            </el-table-column>
            <!-- 商品条码 -->
            <el-table-column
              :label="$t('assocaite.DiologTwo.table.Goods Code')"
              prop="itemCode"
            >
              <el-table-column prop="itemCode" min-width="150" align="center">
                <template slot="header">
                  <el-input
                    v-model="goodsParams.itemCode"
                    size="mini"
                    placeholder=""
                    @input="getItemList"
                    clearable
                  />
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <div style="height: 30px"></div>

          <div class="operateBtnWrap">
            <div class="operateBtn exit" @click="handleExit">
              {{ $t("lcd.Editor.Exit") }}
            </div>
            <div class="operateBtn confirm" @click="handleConfirm">
              {{ $t("button.Confirm") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $Api from "@/libs/api/layout";
import { templatePreview } from '@/libs/api/taskManger.js'
import store from "../../../store/index.js";
export default {
  name: "Preview",
  components: {},
  data() {
    return {
      state: store.state,
      currentPageIdx: 0,
      containerWidth: null,
      containerHeight: null,
      tableData: [],
      goodsParams: {
        itemCode: "",
        itemName: "",
        storeName: "",
      },
      templateSelection: "",
      itemId: "",
    };
  },
  computed: {
    visible: {
      get() {
        return store.state.goodsListVisible;
      },
      set(val) {
        store.updateGoodsListVisible(val);
      },
    },
    programData() {
      return store.state.programInfo;
    },
    currentPageComponentList() {
      return this.programData.pages[this.currentPageIdx].componentList;
    },
    preActive() {
      return this.currentPageIdx > 0;
    },
    nextActive() {
      return this.currentPageIdx < this.programData.pages.length - 1;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentPageIdx = 0;
        this.getWH();
        this.getItemList();
        this.templateSelection = ''
        this.itemId=''
      }
    },
  },
  created() {
    this.getWH();
  },
  methods: {
    handleConfirm() {
      console.log(this.itemId);
      if(this.itemId){
        const params = {
          templateId: this.$route.query.templateId,
          itemId: this.itemId
        }
        localStorage.setItem('previewImg','')
        templatePreview(params).then(res => {
          console.log(res)
          if(res.data.code == 1){
            store.updateGoodsListVisible(false);
            store.updatePreviewEslVisible(true);
            localStorage.setItem('previewImg',res.data.data)
          } else {
            this.$message.error(res.data.message)
          }
        })

      } else {
        this.$message.error(this.$t('lcd.Editor.Please Select Item'))
      }
    },
    handleExit() {
      store.updateGoodsListVisible(false);
    },
    // 获取简化的商品列表
    async getItemList() {
      console.log(this.programData);
      const params = {
        scenarioId: this.$route.query.scenarioId,
        storeId: localStorage.getItem("storeId"),
        storeName: this.goodsParams.storeName,
        itemCode: this.goodsParams.itemCode,
        itemName: this.goodsParams.itemName,
        current: "1",
        size: 8,
      };
      const res = await $Api.getSimplifyList(params);
      console.log(res);
      this.tableData = res.data.records;
    },

    singleElection(row) {
      this.templateSelection = row.itemCode;
      this.itemId = row.itemId;
    },

    getWH() {
      if (!this.$refs.preview) {
        return setTimeout(this.getWH, 1);
      }
      const rect = this.$refs.preview.getBoundingClientRect();
      this.containerWidth = rect.width * 0.8;
      this.containerHeight = rect.height * 0.8;
    },
    handlePre() {
      if (this.preActive) {
        this.currentPageIdx -= 1;
      }
    },
    handleNext() {
      if (this.nextActive) {
        this.currentPageIdx += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/clearfix";
.preview {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  background-color: rgba(0, 0, 0, 0.5);
  .main-area {
    position: absolute;
    left: 10%;
    right: 10%;
    top: calc(10% - 22px);
    bottom: calc(10% - 22px);
    .btns-wrapper {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      @include clearfix;
      .pre,
      .next,
      .exit {
        padding: 8px 14px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
      .pre,
      .next {
        float: left;
        background-color: #808695;
        &.active {
          &:hover {
            background-color: #e3e7ee;
          }
        }
      }
      .exit {
        float: right;
        color: #fff;
        background-color: #ed4014;
        &:hover {
          background-color: #f16643;
        }
      }
      .page-info {
        float: left;
        font-size: 16px;
        padding: 8px 16px;
        z-index: 300;
        background-color: #fff;
        margin-right: 8px;
        border-radius: 4px;
        .curr {
          color: #f66;
        }
      }
    }
  }
  .container {
    width: 800px;
    // height: 500px;
    padding: 30px;
    background-color: #fff;
  }
  .operateBtnWrap {
    text-align: center;
  }
  .operateBtn {
    padding: 10px 30px;
    width: 160px;
    text-align: center;
    line-height: 16px;
    display: inline-block;
    border: 1px solid #e3e7ee;
    margin: 0 15px;
    border-radius: 4px;
    background-color: #35b871;
    color: #fff;
    cursor: pointer;
  }
  .exit {
    background-color: #e3e7ee;
    color: #808695;
    // &:hover {
    //       background-color: #f16643;
    //     }
  }
}
</style>
